<template>
<div>
  <!-- ************************************************** --
    フォーカス時
    -- ************************************************** -->
  <v-row no-gutters class="form-group" v-if="!noLabel">
    <span v-if="label !== ''" class="item-label">{{ label }}</span>
    <span v-else class="item-label" style="color:white" />
    <label class="form-group-label">
      <span v-if="required" class="mandatory">必須</span>
    </label>
  </v-row>
  <v-text-field
    v-if="hasFocus"
    label=""
    v-bind="computedProps"
    v-on="computedListeners"
    :placeholder="phtext"
    :tabindex="readonly ? -1 : 0"
    solo
    flat
  >
    <template v-slot:append>
      <v-btn icon color="primary" dark elevation="0" small v-if="!readonly">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" v-on="on" tabindex="-1" dark elevation="0" small @click="onFindButtonClick">
              <v-icon>mdi-map-marker-distance</v-icon>
            </v-btn>
          </template>
          <span>発地・着地より、登録済みの発着地距離を取得します。<br>※押下後は取得した内容で上書きされます。</span>
        </v-tooltip>
      </v-btn>
    </template>

  </v-text-field>

  <!-- ************************************************** --
    非フォーカス時
    -- ************************************************** -->
  <v-text-field
    v-else
    label=""
    v-bind="computedPropsForText"
    v-on="computedListeners"
    :placeholder="phtext"
    :tabindex="readonly ? -1 : 0"
    solo
    flat
    type="text"
  >
    <template v-slot:append>
      <v-btn icon color="primary" dark elevation="0" small v-if="!readonly">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" v-on="on" tabindex="-1" dark elevation="0" small @click="onFindButtonClick">
              <v-icon>mdi-map-marker-distance</v-icon>
            </v-btn>
          </template>
          <span>発地・着地より登録済みの発着地距離を取得します。<br>※押下後は取得した内容で上書きされます。</span>
        </v-tooltip>
      </v-btn>
    </template>

  </v-text-field>
</div>
</template>
<script>
import flowMixin from '@/mixins/flowMixins'
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import core from '@/rahmen/core'
import { VTextField } from 'vuetify/lib'
import filter from '@/rahmen/utils/filters'

/**
 * @file DDv2用数値テキスト
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須指定
 * @vue-prop {Number} [integerDigit=String(Number.MAX_SAFE_INTEGER).length] - 整数部桁数指定
 * @vue-prop {Number} [minorDigit=0] - 少数部桁数指定
 * @vue-prop {Number} [max=Number.MAX_SAFE_INTEGER] - 許容最大値
 * @vue-prop {Number} [min=Number.MAX_SAFE_INTEGER * -1] - 許容最小値
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-numeric-box
    label="数値"
    v-model="numericValue"
    :required="true"
    :integerDigit="5"
    :minorDigit="2"
    />
 */
export default {
  name: 'DdCalcDistance',
  extends: VTextField,
  mixins: [inputMixin, flowMixin],
  components: {
  },
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 正数部桁数指定
     */
    integerDigit: {
      type: Number,
      default: String(Number.MAX_SAFE_INTEGER).length
    },
    /**
     * 小数部桁数指定
     */
    minorDigit: {
      type: Number,
      default: 0
    },
    /**
     * 入力可能最大値
     */
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    /**
     * 入力可能最小値
     */
    min: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER * -1
    },
    /**
     * ラベル不要
     */
    noLabel: {
      type: Boolean,
      default: false
    },
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * 発着地距離取得用パラメータ
     */
    searchDate: {
      type: String,
      default: filter.dateFormatter(new Date())
    },
    hatsuchiCd: String,
    chakuchiCd: String,
    torihikisakiCd: String
    // ここまで
  },
  data: () => ({
    hasFocus: false,
    formatedText: '',
    isNegativeValue: false,
    invalidMessage: '',
    innerValue: ''
  }),
  created () {
    this.formatedText = this.value
    this.innerValue = this.getSanitizedValue(this.value)
  },
  mounted () {
    console.log(this.name, 'mounted', this)
    this.invalidMessage = this.errorMessages
    console.log('formatedText', this.formatedText)
  },
  watch: {
    /* readonly: function (n, o) {
      this.isReadonly = n
    }, */
    value: function (n, o) {
      this.innerValue = this.getSanitizedValue(n)
      this[controls.FORMAT_METHOD]()
    }
  },
  computed: {
    inputTypeDetail () {
      return controls.getInputTypeDetail(controls.InputTypes.Numerical)
    },
    phtext () {
      if (!this.inputTypeDetail) {
        return ''
      } else {
        return !this.readonly ? this.inputTypeDetail.placeholder.replace('@@length@@', this.integerDigit) : ''
      }
    },
    computedProps () {
      return {
        ...this.$props,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        type: 'number',
        hideDetails: 'auto',
        dense: true,
        value: this.innerValue,
        class: this.$props.class + ' numeric-input' + (this.readonly ? ' readonly-item' : this.required ? ' required-item' : ''),
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedPropsForText () {
      return {
        ...this.$props,
        type: 'text',
        hideDetails: 'auto',
        dense: true,
        value: this.formatedText,
        class: this.$props.class + ' numeric-input' + (this.isNegativeValue ? ' negative' : '') + (this.readonly ? ' readonly-item' : this.required ? ' required-item' : ''),
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    }
  },
  methods: {
    getSanitizedValue (inputVal) {
      if (typeof inputVal === 'string' && inputVal !== '') {
        var retVal = inputVal.replaceAll(',', '')
        if (isFinite(retVal)) {
          return parseFloat(retVal)
        } else {
          return ''
        }
      }
      return inputVal
    },
    onFindButtonClick: function (e) {
      if ([undefined, null, ''].includes(this.hatsuchiCd) || [undefined, null, ''].includes(this.chakuchiCd)) { return }
      this.clearSummaryMessage()
      const rec = {
        searchDate: this.searchDate,
        hatsuchiCd: this.hatsuchiCd,
        chakuchiCd: this.chakuchiCd,
        torihikisakiCd: this.torihikisakiCd
      }
      this.HttpClient.post('/api/v1/mstHacchakuchiKyori/GetHacchakuchiDistance', rec)
        .then((data) => {
          if (data.isValid) {
            this.hacchakuchiKyoriInfo = data.payload
            if (this.hacchakuchiKyoriInfo) {
              if (this.hacchakuchiKyoriInfo.kyoriKm) {
                this.$emit('set', this.hacchakuchiKyoriInfo)
              } else {
                this.setInvalidSummaryMessage('COMI0101')
              }
            }
          } else {
            this.setInvalidSummaryMessage('COMI0101')
          }
        })
    },
    onBlur: function (e) {
      console.log('onBlur', e, this.hasFocus)
      this.$set(this, 'hasFocus', false)
      console.log(this.computedPropsForText)
      console.log(this.hasFocus)
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      } else {
        this.formatedText = this.innerValue
      }
      this.$emit('blur', e)
    },
    onFocus: function (e) {
      console.log('onFocus', e, this.hasFocus)
      this.$set(this, 'hasFocus', true)
      console.log(this.hasFocus)
      let val = '' + e.target.value
      val = val.replaceAll(',', '')
      e.target.value = val

      const elem = this.$el.querySelector('input')
      if (elem) { elem.select() }

      this.$emit('focus', e)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        intDigit: this.integerDigit,
        decimalDigit: this.minorDigit,
        max: this.max,
        min: this.min
      }
      console.log(target)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(controls.InputTypes.Numerical)

      if (!this.required && target.value === '') { return }
      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
      const val = String(this.innerValue)
      if (val === 'undefined' || val === '' || val === 'null') {
        this.formatedText = ''
        return
      }
      const num = this.minorDigit === 0 ? parseInt(val, 10) : parseFloat(val, 10)
      let formated = num.toLocaleString(undefined, { maximumFractionDigits: 20 })

      if (this.minorDigit !== 0) {
        console.log('1', formated)
        const dotPosition = formated.lastIndexOf('.')
        if (dotPosition === -1) {
          formated += `.${'0'.repeat(this.minorDigit)}`
        } else {
          const minorLen = formated.split('.')[1].length
          formated += '0'.repeat(this.minorDigit - minorLen)
        }
      }

      this.formatedText = formated
      this.isNegativeValue = core.isNegativeValue(val)
    },
    onCalcDistanceClick: function () {
      return true
    }
  }
}
</script>
<style>
.numeric-input input {
  text-align: right;
}

.numeric-input.negative input {
  color: red;
}
</style>
